$(function () {
    $('[data-toggle="popover"]').popover();
});

$(document).on('click', function (e) {
    $('[data-toggle="popover"],[data-original-title]').each(function () {
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
            (($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false  // fix for BS 3.3.6
        }
    });
});


// [foreign, domestic]
var health_0_60_val = 0;
var health_61_70_val = 0;
var health_71_80_val = 0;
$("[data-toggle=popover]").on('shown.bs.popover', function () {
    var id =' #personCount';
    var p = $(this).closest('.tab-pane');
    var parent = '#' + p.attr('id');
    var $health_0_60 = $('body').find(parent + " input[name='health_persons_0_60']");
    var $health_61_70 = $('body').find(parent + " input[name='health_persons_61_70']");
    var $health_71_80 = $('body').find(parent + " input[name='health_persons_71_80']");

    $health_0_60.TouchSpin({
        min: 0,
        max: 200,
        step: 1,
        initval: health_0_60_val,
        buttondown_class: "btn btn-info",
        buttonup_class: "btn btn-info"
    });
    $health_0_60.on('change', function () {
        health_0_60_val = $(this).val();
        change_health_number(parent, id);
    });

    $health_61_70.TouchSpin({
        min: 0,
        max: 200,
        step: 1,
        initval: health_61_70_val,
        buttondown_class: "btn btn-info",
        buttonup_class: "btn btn-info"
    });
    $health_61_70.on('change', function () {
        health_61_70_val = $(this).val();
        change_health_number(parent, id);
    });

    $health_71_80.TouchSpin({
        min: 0,
        max: 200,
        step: 1,
        initval: health_71_80_val,
        buttondown_class: "btn btn-info",
        buttonup_class: "btn btn-info"
    });
    $health_71_80.on('change', function () {
        health_71_80_val = $(this).val();
        change_health_number(parent, id);
    });
   

});
function change_health_number(parent, id) {
    var val = parseInt(health_0_60_val) + parseInt(health_61_70_val) + parseInt(health_71_80_val);
    $('body').find(parent + id).val(val);
}


var healthInsuranceSearch = function (health_type, health_birthday, health_birthmonth, health_birthyear, health_insurer) {
    function showFieldError($field, message) {
        var $target = $field;
        if ($field && $field.length) {
            if ($field.hasClass('select2-hidden-accessible')) {
                $target = $field.next('.select2');
            } else if ($field.next('.select2').length) {
                $target = $field.next('.select2');
            } else if ($field.next().length && !$field.is('input[type="text"], input[type="tel"], textarea')) {
                $target = $field.next();
            }
            try {
                $target.animateCss('shake');
            } catch (e) {}
            $target.addClass('health-field-error');
            setTimeout(function () {
                $target.removeClass('health-field-error');
            }, 2500);
        }
        if (typeof Swal !== 'undefined') {
            Swal.fire({
                icon: 'warning',
                title: 'توجه',
                text: message,
                confirmButtonText: 'باشه',
                confirmButtonColor: '#ED6D37'
            });
        } else {
            alert(message);
        }
        return false;
    }

    function padPart(value) {
        var n = parseInt(value, 10);
        if (isNaN(n)) return '';
        return n < 10 ? '0' + n : String(n);
    }

    var url_param = '';
    url_param += '?type=' + health_type;
    if(health_type == 'group'){
        if (
            parseInt(health_0_60_val) == 0 &&
            parseInt(health_61_70_val) == 0 &&
            parseInt(health_71_80_val) == 0
        ) {
            return showFieldError($('#groupHealthInsurance #personCount'), 'لطفاً تعداد افراد و بازه سنی را مشخص کنید.');
        }
        if (health_insurer.val() == -1 || health_insurer.find("option:selected").text() == "") {
            return showFieldError(health_insurer, 'لطفاً بیمه‌گر پایه را انتخاب کنید.');
        }
        var range_string = '&ageRange=';
        range_string += '0_60-' + parseInt(health_0_60_val) + ',';
        range_string += '61_70-' + parseInt(health_61_70_val) + ',';
        range_string += '71_80-' + parseInt(health_71_80_val);
        url_param += range_string;
        var healthinsurer = health_insurer.find("option:selected").val();
        if(healthinsurer && healthinsurer != -1) {
            url_param += '&insurer=' + healthinsurer;
        }
        window.location = grouphealthInsuranceSearchUrl + '/'  + url_param;
    }else{
        if (health_birthday.val() == 'NAN') {
            return showFieldError(health_birthday, 'لطفاً روز تولد را انتخاب کنید.');
        }
        if (health_birthmonth.val() == 'NAN') {
            return showFieldError(health_birthmonth, 'لطفاً ماه تولد را انتخاب کنید.');
        }
        if (health_birthyear.val() == 'NAN') {
            return showFieldError(health_birthyear, 'لطفاً سال تولد را انتخاب کنید.');
        }
        if (health_insurer.val() == -1 || health_insurer.find("option:selected").text() == "") {
            return showFieldError(health_insurer, 'لطفاً بیمه‌گر پایه را انتخاب کنید.');
        }

        var healthbirthday = health_birthday.val();
        var healthbirthmonth = health_birthmonth.val();
        var healthbirthyear = health_birthyear.val();
        var birthDate = healthbirthyear + '/' + padPart(healthbirthmonth) + '/' + padPart(healthbirthday);
        var healthinsurer = health_insurer.find("option:selected").val();

        if (birthDate) {
            url_param += '&birthday=' + birthDate;
        }
        if(healthinsurer && healthinsurer != -1) {
            url_param += '&insurer=' + healthinsurer;
        }
        window.location = healthInsuranceSearchUrl + '/'  + url_param;
    }


}
$(document).ready(function () {
    // Fallback tab switcher (works with BS3 data-toggle and BS5 data-bs-toggle)
    $('#health-insurance-tab').on('click', '.tab-container > ul.tabs > li > a[href^="#"]', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $link = $(this);
        var target = $link.attr('href');
        var $container = $link.closest('.tab-container');

        $container.children('ul.tabs').children('li').removeClass('active');
        $link.parent('li').addClass('active');

        $container.children('.tab-content').children('.tab-pane')
            .removeClass('active in show');
        $container.children('.tab-content').children(target)
            .addClass('active in show');

        try {
            if (typeof $link.trigger === 'function') {
                $link.trigger($.Event('shown.bs.tab', { relatedTarget: target }));
            }
        } catch (err) {}
    });

    $('.health_insurance_searchBtn_top').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var type = $(this).data('type');
        var parent = '#singleHealthInsurance';
        if (type === 'family') {
            parent = '#familyHealthInsurance';
        }
        if(type === 'group') {
            parent = '#groupHealthInsurance';
        }
        var health_birthday = $(parent + ' .birth_day_select').first();
        var health_birthmonth = $(parent + ' .birth_month_select').first();
        var health_birthyear = $(parent + ' .birth_year_select').first();
        var health_insurer = $(parent + ' .health_insurer_select, ' + parent + ' select[name="health_insurer"]').first();
        healthInsuranceSearch(type, health_birthday, health_birthmonth, health_birthyear, health_insurer);
        return false;
    });
});

$.fn.extend(
    {
        animateCss: function (animationName) {
            var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            this.addClass('animated ' + animationName).one(
                animationEnd, function () {
                    $(this).removeClass('animated ' + animationName);
                }
            );
        }
    }
);
